import React, {useMemo} from "react";
import {observer} from "mobx-react-lite";
import {useLocation} from "react-router";
import {Button} from "@mui/material";
import {environment} from "../../env";
import {resolveLoginRouteState} from "../routing/LoginRouteState";
import {useAuth0Login} from "./useAuth0Login";

export const Auth0LoginButton: React.FC = observer(() => {
    const location = useLocation();
    const loginIntention = useMemo(() => resolveLoginRouteState(location), [location]);
    const autoLogin = Boolean(loginIntention.loginIntention.autoLogin);

    const {login, isLoggingIn} = useAuth0Login({loginIntention, autoLogin});

    if (!isLoggingIn) {
        return <Button
            variant={environment.hasMultipleAuthProviders ? 'outlined' : 'contained'}
            onClick={() => login()}>
            Log in
            {environment.hasMultipleAuthProviders && <><br/>(2024 version)</>}
        </Button>
    }

    return <></>;
});
